import React, {useState} from "react";
import "./registerUser.css";
import {useHistory} from "react-router-dom";
import services from "../../Services/services";
import bcrypt from "bcryptjs";

// Form used for registration.
const RegistrationForm = () => {
    const tempStr = "";
    let [name, setName] = useState('');
    let [email, setEmail] = useState('');
    let [zipCode, setZipcode] = useState('');
    let [userId, setuserId] = useState('');
    let [password, setPassword] = useState('');
    let [cpassword, csetPassword] = useState('');
    let [uType, setUType] = useState('1');
    let [error, setError] = useState('');

    //This is for the privacy checkbox in the register page.
    let [checked, setChecked] = useState('');
    const history = useHistory();

    const createUser = (user) =>
        services.addNewUser({
            "name" : name,
            "email":email,
            "zipCode" : zipCode,
            "userId": userId,
            "password": bcrypt.hashSync(password, '$2a$10$CwTycUXWue0Thq9StjUM0u'),
            "uType":uType
        })
            .then(status => history.push('/login'))
            .catch((e) =>{
                console.log(e);
                setError(e);
                }
            )

    return(
        <div className=" wd-border-form">
            <div className="form-group mt-5">
                <div className=" p-1 m-4">
                    <label htmlFor="name" className="form-label m-0" style={{color:"gray"}}>Name</label>
                    <input className="form-control wd-input p-0" onChange={(event) =>
                        setName(event.target.value)} style={{color:"black"}}>
                    </input>
                </div>
                <div className=" p-1 m-4">
                    <label htmlFor="Bio" className="form-label m-0" style={{color:"gray"}}>Email</label>
                    <input type="email" className="form-control wd-input p-0" onChange={(event) =>
                        setEmail(event.target.value)}  id="email" aria-describedby="email" style={{color:"black"}}>
                    </input>
                </div>
                <div className="wd-border-form p-1 m-4">
                    <label htmlFor="location" className="form-label m-0" style={{color:"gray"}}>ZipCode</label>
                    <input className="form-control wd-input p-0" onChange={(event) =>
                        setZipcode(event.target.value)}  id="location" aria-describedby="location" style={{color:"black"}}>
                    </input>
                </div>
                <div className="wd-border-form p-1 m-4">
                    <label htmlFor="location" className="form-label m-0" style={{color:"gray"}}>User Type</label>
                    <select className="form-select" onChange={(event) =>
                        setUType(event.target.value)}>
                        <option value="1" selected>Customer</option>
                        <option value="2">Restaurant Owner</option>
                    </select>
                </div>
                <div className="wd-border-form p-1 m-4">
                    <label htmlFor="website" className="form-label m-0" style={{color:"gray"}}>UserId</label>
                    <input className="form-control wd-input p-0" onChange={(event) =>
                        setuserId(event.target.value)}  id="userid" aria-describedby="website" style={{color:"black"}}>
                    </input>
                </div>
                <div className="wd-border-form m-4">
                    {
                        error && <label htmlFor="website" className="form-label m-0" style={{color:"red"}}>UserId not available</label>
                    }

                </div>
                <div className="wd-border-form p-1 m-4">
                    <label htmlFor="website" className="form-label m-0" style={{color:"gray"}}>Password</label>
                    <input type="password" className="form-control wd-input p-0" onChange={(event) =>
                        setPassword(event.target.value)}  id="password" aria-describedby="website" style={{color:"black"}}>
                    </input>
                </div>
                <div className="wd-border-form p-1 m-4">
                    <label htmlFor="website" className="form-label m-0" style={{color:"gray"}}>Confirm Password</label>
                    <input type="password" className="form-control wd-input p-0" onChange={(event) =>
                        csetPassword(event.target.value)}  id="password" aria-describedby="website" style={{color:"black"}}>
                    </input>
                </div>
                <div className="wd-border-form p-1 m-4 mt-0">
                    {
                        password != cpassword && <label htmlFor="website" className="form-label m-0" style={{color:"red"}}>Passwords don't match</label>
                    }
                </div>
                <div>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked"  onClick={(e) => setChecked(e.target.checked)}/>
                    <label className="form-check-label" for="flexCheckChecked">
                        Click here to accept the terms and conditions.<a href="#" data-toggle="modal" data-target="#privacyModal" className="link-primary">Click here to read the terms and conditions</a>
                    </label>
                </div>
                    {/**This defines the modal for the privacy policy*/}
                    <div className="modal fade" id="privacyModal" tabindex="-1" role="dialog" aria-labelledby="privacyModal" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Privacy policy</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    Food Mafia Limited respects your privacy and is committed to protecting it through its compliance with its privacy policies.  This policy describes:
                                    <ul>
                                        <li>the types of information that Food Mafia may collect from you when you access or use its website.</li>
                                        <li>its practices for collecting, using, maintaining, protecting and disclosing that information.
                                        </li>
                                    </ul>
                                    <h6>Information You Provide to Us</h6>
                                        The information we collect on or through our Services may include:
                                        <ul>
                                            <li>Your account information: Your full name, email address, zip code, password and other information you may provide with your account.</li>
                                            <li>Your content: Information you provide through our Services, including your reviews, bookmarked restaurants other information in your account profile.</li>
                                            <li>Your searches and other activities: The search terms you have looked up and results you selected.</li>
                                            <li>Your Public Posts: You also may provide information (such as ratings, bookmarks etc.) to be published or displayed (hereinafter, "posted") on publicly accessible areas of our Services. Your User Contributions are posted on and transmitted to others at your own risk. We limit access to certain pages. We may display this information on the Services, share it with businesses, and further distribute it to a wider audience through third party sites and services. You should be careful about revealing any sensitive details about yourself in such postings.</li>
                                        </ul>
                                    <h6>How we use the information we collect</h6>
                                    We use the information we collect from and about you for a variety of purposes, including to:
                                        <ul>
                                            <li>Understand our users (what they do on our Services, what features they like, how they use them, etc.), improve the content and features of our Services (such as by personalizing content to your interests).</li>
                                            <li>Administer our Services and diagnose technical problems.</li>
                                            <li>Generate and review reports and data about, and to conduct research on, our user base and Service usage patterns.</li>
                                            <li>Provide you with customer support.</li>
                                            <li>Provide you with policies about your account.</li>
                                            <li>Notify you about changes to our Services.</li>
                                            <li>In any other way we may describe when you provide the information.</li>
                                            <li>For any other purpose with your consent.</li>
                                        </ul>
                                        
                                        We may disclose personal information that we collect or you provide, as described in this privacy policy, in the following ways:    
                                        <h6>General Information Disclosures</h6>
                                        <ul>
                                            <li>To our subsidiaries and affiliates, which are entities under common ownership or control of our ultimate parent company Food Mafia.</li>
                                            <li>To the restaurant owner when you posted reviews.</li>
                                            <li>To fulfill the purpose for which you provide it.</li>
                                            <li>For any other purpose disclosed by us when you provide the information.</li>
                                            <li>Consent. We may share your information in any other circumstances where we have your consent.</li>
                                        </ul>	
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    {/*<Link to = "/login ">*/}
                        {
                            checked && name && email && zipCode && userId &&
                            password == cpassword && <button className="btn btn-primary rounded-pill wd-register-button m-4" onClick={createUser}> Register </button>
                        }
                    {/*</Link>*/}
                        {

                            (!name || !checked || !email || !zipCode || !userId ||
                            password != cpassword) && <button className="btn btn-primary rounded-pill wd-register-button m-4" disabled> Register </button>
                        }
                </div>
            </div>
        </div>
    )
};
export default RegistrationForm;